// Vendor
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
// Styles
import './style.styl';

const Spinner = ({ className, size, borderWidth, currentColor, ...props }) => {
  const componentStyles = {
    width: size,
    height: size,
    marginTop: -(size / 2),
    marginLeft: -(size / 2),
    borderWidth: borderWidth,
  };
  const spinsStyles = {
    left: -borderWidth,
    top: -borderWidth,
  };
  const componentClasses = cn({
    Spinner: true,
    Spinner_currentColor: currentColor,
    [className]: className,
  });

  return (
    <span className={componentClasses} style={componentStyles} {...props}>
      <span className="Spinner__before" style={spinsStyles} />
      <span className="Spinner__after" style={spinsStyles} />
    </span>
  );
};

Spinner.defaultProps = {
  className: '',
  size: 48,
  borderWidth: 3,
  currentColor: false,
};

Spinner.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
  borderWidth: PropTypes.number,
  currentColor: PropTypes.bool,
};

export default Spinner;



// WEBPACK FOOTER //
// components/Spinner/index.js